import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityActionTemplateByUrlSlice } from './post';

export const coreDataSecurityActionTemplateByUrlReducers = combineReducers({
	post: postCoreDataSecurityActionTemplateByUrlSlice.asyncReducers
});

export const coreDataSecurityActionTemplateByUrlWatchers = combineAllWatchers([
	postCoreDataSecurityActionTemplateByUrlSlice.asyncWatchers
]);
